import { makeStyles, TextField, Link as MuiLink, Select, FormControl, InputLabel } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send';
import { useForm, Controller } from 'react-hook-form'
import ButtonSp from '../../components/ui/ButtonSp'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    minHeight: 320,
    overflow: 'auto',
    padding: theme.spacing(1),
    position: 'relative',
  },
  title: {
    ...theme.homeStyle.bodyText,
    color: theme.palette.primary.main,
    margin: `${theme.spacing(0)}px 0`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  field: {
    marginTop: theme.spacing(1),
  },
  buttonsGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  copyRight: {
    fontSize: 10,
    color: 'grey',
    position: 'absolute',
    bottom: 0,
  },
}))

const boxSizesKeysAndLabelsWithUndefined = [
  ['document', 'ซอง A3/A4'],
  ['ก', 'ไปรษณีย์ ก. (14x20x6 cm)'],
  ['ข', 'ไปรษณีย์ ข. (17x25x9 cm)'],
  ['ค', 'ไปรษณีย์ ค. (20x30x11 cm)'],
  ['ง', 'ไปรษณีย์ ง. (22x35x14 cm)'],
  ['จ', 'ไปรษณีย์ จ. (24x40x17 cm)'],
  ['ฉ', 'ไปรษณีย์ ฉ. (30x45x20 cm)'],
  ['box0', 'กล่องเบอร์ 0 (11x17x6 cm)'],
  ['box1', 'กล่องเบอร์ 1 (30x100x30 cm)'],
  ['box2', 'กล่องเบอร์ 2 (31x36x13 cm)'],
  ['box3', 'กล่องเบอร์ 3 (31x36x26 cm)'],
  ['box4', 'กล่องเบอร์ 4 (55x100x55 cm)'],
  ['box5', 'กล่องเบอร์ 5 (40x45x35 cm)'],
  ['box6', 'กล่องเบอร์ 6 (45x55x40 cm)'],
]

const CheckpriceEmbed = () => {

  const classes = useStyles()
  const { register, handleSubmit, errors, reset, control } = useForm()

  const onFormSubmit = handleSubmit(data => {
    window.open(`/checkprice?postcode_from=${data.origin}&postcode_to=${data.dest}&weight=${data.weight}&size_parcel=${data.boxSize}&service_type=${data.serviceType}`)
  })

  const onReset = () => {
    reset()
  }

  const renderField = (name, label, isPostcode = false) => (
    <TextField
      variant="outlined"
      fullWidth
      label={label}
      name={name}
      inputRef={register({ required: true, maxLength: isPostcode ? 5 : 100, minLength: isPostcode ? 5 : 0 })}
      type="number"
      size="small"
      className={classes.field}
      error={errors[name]}
    />
  )

  return (
    <form className={classes.root} onSubmit={onFormSubmit}>
      <p className={classes.title}><SendIcon fontSize="small" style={{ marginRight: 8 }}/> คำนวณราคาค่าขนส่ง</p>
      {renderField('origin','รหัส ปณ. ต้นทาง',true)}
      {renderField('dest','รหัส ปณ. ปลายทาง',true)}
      {renderField('weight','น้ำหนัก (กรัม)')}
      <FormControl variant="outlined" fullWidth size="small" className={classes.field}>
        <InputLabel error={errors.boxSize}>ขนาดกล่อง</InputLabel>
        <Controller
          as={
            <Select
              variant="outlined"
              label="ขนาดกล่อง"
              fullWidth
              native
              error={errors.boxSize}
              size="small"
            >
              <option value="" hidden />
              {boxSizesKeysAndLabelsWithUndefined.map(([name, label]) => (
                <option value={name} key={name}>
                  {label}
                </option>
              ))}
            </Select>
          }
          control={control}
          name="boxSize"
          defaultValue=""
          rules={{ required: true }}
        />
      </FormControl>
      <div className={classes.buttonsGroup}>
        <ButtonSp type="submit" size="small" className={classes.button}>คำนวณราคา</ButtonSp>
        <ButtonSp onClick={onReset} size="small" color="default" className={classes.button}>ล้างข้อมูล</ButtonSp>
      </div>
      <p className={classes.copyRight}>
        © Copyright 2015 - {new Date().getFullYear()} All Rights Reserved by{' '}
        <MuiLink href="https://www.shippop.com/" target="_blank">
          SHIPPOP
        </MuiLink>
      </p>
    </form>
  )
}

export default CheckpriceEmbed
